<template>
   <el-dialog
        :visible.sync="phoneVisible"
        :show-close="false"
        class="phone"
        append-to-body
        center
        width="300px"
        :before-close="handleClose">
        <div style="text-align:center">
            <div class="phone_title">{{selectItem.title}}</div>
            <div class="phone_msg">请拨打电话</div>
            <div class="phone_num">{{selectItem.phone}}</div>
            <div class="phone_action">
                <el-button type="primary" @click="$emit('update:phoneVisible',false)">确定</el-button>
            </div>
        </div>
   </el-dialog>
</template>

<script>
export default {
    props:["phoneVisible","selectItem"],
   data (){
       return {
           
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       handleClose(){
           this.$emit("update:phoneVisible",false);
       }
   },
   created() {
       
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.phone{
    
    &_title{
        color:#333;
        font-size: 20px;
        font-weight: 500;
    }
    &_msg{
        color:#333;
        font-size: 16px;
        margin:24px 0 16px 0;
    }
    &_num{
        color:#333;
        font-size: 24px;
        font-weight: 600;
    }
    &_action{
        margin-top:20px;
        /deep/ .el-button{
            width:104px;
            padding: 11px 19px;
            font-size: 16px;
            font-weight: normal;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/orderList/components/phoneModal.vue